import {
  FETCH,
  FETCH_ARTICLE_PAGE,
  RECEIVED,
  RECEIVED_ARTICLE_PAGE,
  error,
  received,
  receivedArticlePage,
} from '../store/modules/author'
import { map as fmap, join } from 'ramda'
import { combineEpics, ofType } from 'redux-observable'
import { map, mergeMap, withLatestFrom } from 'rxjs'
import { logObservableErrorAndTriggerAction, logObservableError } from '../utilities/logs'
import { formatArticle } from '../utilities/miscellaneous'
import { calculateTotalPages } from '../utilities/paginations'
import { receivedPage, error as paginationError } from '../store/modules/pagination'
import { injectAuthorSchema } from '../store/modules/header'

// fetchCurrentAuthorEpic :: Epic -> Observable Action.RECEIVED
export const fetchCurrentAuthorEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(FETCH),
    withLatestFrom(state$),
    mergeMap(([ _, state ]) => fetchApi(`/v2/${state.router.locale}/signatures/${state.router.activeRoute.params.author}`)),
    map(response => received(response.body)),
    logObservableErrorAndTriggerAction('author :: fetchCurrentAuthorEpic', error, logger),
  )

// fetchArticlesFromCurrentAuthorEpic :: Epic -> Observable Action.RECEIVED_ARTICLE_PAGE
export const fetchArticlesFromCurrentAuthorEpic = (action$, state$, { document, fetchApi, logger }) =>
  action$.pipe(
    ofType(FETCH_ARTICLE_PAGE),
    withLatestFrom(state$),
    mergeMap(([ { page, size }, state ]) => Promise.all([
      fetchApi(join('', [
        `/v2/${state.router.locale}/contents/search`,
        `?signatures=${state.author.current.id}`,
        `&page=${page}`,
        `&limit=${size}`,
        `&countable=1`,
      ])),
      page,
      size,
      state.router.locale,
    ])),
    map(([ response, page, size, locale ]) => receivedArticlePage(
      page,
      calculateTotalPages(
        Number(response.headers.get('Total-Result') || 0),
        size,
      ),
      document.documentElement.scrollHeight,
      document.documentElement.scrollTop,
      fmap(article => formatArticle(locale, article))(response.body || []),
    )),
    logObservableErrorAndTriggerAction('author :: fetchArticlesFromCurrentAuthorEpic', paginationError, logger),
  )

// updatePaginationEpic :: Epic -> Action.RECEIVED_PAGE
export const updatePaginationEpic = (action$, _, { logger }) =>
  action$.pipe(
    ofType(RECEIVED_ARTICLE_PAGE),
    map(({ page, totalPages, scrollHeight, scrollTop }) => receivedPage(page, totalPages, scrollHeight, scrollTop)),
    logObservableError('author :: updatePaginationEpic', logger),
  )

// injectAuthorSchemaEpic :: Epic -> Action.INJECT_AUTHOR_SCHEMA
export const injectAuthorSchemaEpic = (action$, _, { logger }) =>
  action$.pipe(
    ofType(RECEIVED),
    map(({ current }) => injectAuthorSchema(current)),
    logObservableError('author :: injectAuthorSchemaEpic', logger),
  )
  
export default combineEpics(
  fetchCurrentAuthorEpic,
  fetchArticlesFromCurrentAuthorEpic,
  updatePaginationEpic,
  injectAuthorSchemaEpic,
)
